class NewsletterSubscriptionTracker extends HTMLElement {
  constructor() {
    super();
    this.listenerAddedNl = false;
  }

  connectedCallback() {
    this.addEventListenerToSubscribeButton();
    this.observeDOMChanges();
  }

  trackNewsletterEvent() {
    console.log('Publishing event newsletter_subscription');
    window.Shopify.analytics.publish('newsletter_subscription', {
      url: window.location.href
    });
  }

  addEventListenerToSubscribeButton() {
    const subscribeButton = this.querySelector('.newsletter-btn');
    if (subscribeButton && !this.listenerAddedNl) {
      subscribeButton.addEventListener('click', () => {
        this.trackNewsletterEvent();
      });
      this.listenerAddedNl = true; 
    }
  }

  observeDOMChanges() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          this.addEventListenerToSubscribeButton();
        }
      });
    });

    const config = { childList: true, subtree: true };
    observer.observe(document, config);
  }
}

customElements.define('newsletter-subscription-tracker', NewsletterSubscriptionTracker);

class GTMEvents {
  // static method to set listeners
  static setListeners() {
    this.setReturnButtonListener();
    this.setNewsletterButtonListener();
  }

  // method for tracking the Returns event
  static trackReturnEvent() {
    console.log('Publishing event create_or_check_returns');
    window.Shopify.analytics.publish('create_or_check_returns', {
      url: window.location.href
    });
  }

  // method to set the listener on the Returns button
  static setReturnButtonListener() {
    let listenerAdded = false;
    
    const submitReturn = () => {
      const buttonReturns = document.querySelector('#check-order-return .btn');
      if (buttonReturns && !listenerAdded) {
        buttonReturns.addEventListener('click', () => {
          console.log('click on submit Return');
          this.trackReturnEvent();
        });
        listenerAdded = true; 
      }
    };

    // observer to monitor changes in the DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          submitReturn();
        }
      });
    });

    const config = { childList: true, subtree: true };
    observer.observe(document, config);

    document.addEventListener('DOMContentLoaded', () => {
      submitReturn();
    });
  }

  // method to set the listener on the newsletter button
  static setNewsletterButtonListener() {
    const newsletterElement = document.querySelector('newsletter-subscription-tracker');
    if (newsletterElement) {
      newsletterElement.addEventListenerToSubscribeButton();
    }
  }
}

// run the code to set listeners only after the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  GTMEvents.setListeners();
});

